import { WeatherInfoDisplay } from 'components';
import { WeatherContext } from 'pages/Forecast';
import React, { useContext } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import 'styles/global.css';
import { GetWeatherTimeString } from 'utils/stringUtils';
import styles from './HourlyForecast.module.css';

export default function HourlyForecast() {
  const weatherContext = useContext(WeatherContext);
  const hourlyForecast = weatherContext?.hourly ?? [];

  const firstForecastDate = hourlyForecast[0]?.iso8601
    ? new Date(hourlyForecast[0].iso8601).toDateString()
    : null;

  return (
    <Container fluid className="d-flex flex-column h-100 user-select-none gap-3 px-0">
      {firstForecastDate && (
        <div className={styles.title}>{`${firstForecastDate} Hourly Forecast`}</div>
      )}

      <div className={[styles.contentContainer, 'overflow-hidden']}>
        <Row className="g-4">
          {hourlyForecast.map((item) => (
            <Col xs={12} md={6} key={item?.iso8601} className="d-flex">
              <WeatherInfoDisplay
                data={item}
                title={GetWeatherTimeString(new Date(item?.iso8601))}
              />
            </Col>
          ))}
        </Row>
      </div>
    </Container>
  );
}
